// Generated by purs version 0.15.16
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var pure = function (dict) {
    return dict.pure;
};
var unless = function (dictApplicative) {
    var pure1 = pure(dictApplicative);
    return function (v) {
        return function (v1) {
            if (!v) {
                return v1;
            };
            if (v) {
                return pure1(Data_Unit.unit);
            };
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var when = function (dictApplicative) {
    var pure1 = pure(dictApplicative);
    return function (v) {
        return function (v1) {
            if (v) {
                return v1;
            };
            if (!v) {
                return pure1(Data_Unit.unit);
            };
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var liftA1 = function (dictApplicative) {
    var apply = Control_Apply.apply(dictApplicative.Apply0());
    var pure1 = pure(dictApplicative);
    return function (f) {
        return function (a) {
            return apply(pure1(f))(a);
        };
    };
};
var applicativeProxy = {
    pure: function (v) {
        return Type_Proxy["Proxy"].value;
    },
    Apply0: function () {
        return Control_Apply.applyProxy;
    }
};
var applicativeFn = {
    pure: function (x) {
        return function (v) {
            return x;
        };
    },
    Apply0: function () {
        return Control_Apply.applyFn;
    }
};
var applicativeArray = {
    pure: function (x) {
        return [ x ];
    },
    Apply0: function () {
        return Control_Apply.applyArray;
    }
};
export {
    pure,
    liftA1,
    unless,
    when,
    applicativeFn,
    applicativeArray,
    applicativeProxy
};
export {
    apply
} from "../Control.Apply/index.js";
export {
    map,
    void
} from "../Data.Functor/index.js";
//# sourceMappingURL=index.js.map
